import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCrudHooks, processResult } from "../common/queries";
import api from "../http-common";

export const activityApi = {
	...createCrudHooks({
		baseKey: "activities",
		basePath: "/activities",
		getParams: { include: [{ association: 'courseDetail', include: [{ association: 'course', include: ['subject'] }, 'parentDetail'] }, { association: 'enrollment', include: ['student'] }] },
	}),

	useReschedule() {
		const qc = useQueryClient();
		return useMutation({
			mutationFn: ({ id, date, cascade = true }) => api.post(`/activities/${id}/_reschedule`, { date, cascade }).then(r => processResult(qc, r)),
		});
	},

	useUnschedule() {
		const qc = useQueryClient();
		return useMutation({
			mutationFn: ({ id, cascade = true }) => api.post(`/activities/${id}/_unschedule`, { cascade }).then(r => processResult(qc, r)),
		});
	},

	useCompletePrevious() {
		const qc = useQueryClient();
		return useMutation({
			mutationFn: (id) => api.post(`/activities/${id}/_completePrevious`).then(r => processResult(qc, r)),
		});
	},
};
